import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import { rootReducer } from "./combineReducers";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
 const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]

});    

const persistor = persistStore(store);
export { store, persistor };
